/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, n: NonNullable<unknown>, of: NonNullable<unknown> }} Plan_Edit_PositionInputs */

const en_us2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: position ${i?.n} of ${i?.of}`)
};

const pt_br2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posição ${i?.n} de ${i?.of}`)
};

const es_419_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posición ${i?.n} de ${i?.of}`)
};

const pt_pt2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posição ${i?.n} de ${i?.of}`)
};

const fr_fr2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} : position ${i?.n} sur ${i?.of}`)
};

const de_de2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: Position ${i?.n} von ${i?.of}`)
};

const it_it2_plan_edit_position = /** @type {(inputs: Plan_Edit_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posizione ${i?.n} di ${i?.of}`)
};

/**
* | output |
* | --- |
* | "{name}: position {n} of {of}" |
*
* @param {Plan_Edit_PositionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_position = /** @type {((inputs: Plan_Edit_PositionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_PositionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_position(inputs)
	if (locale === "es-419") return es_419_plan_edit_position(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_position(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_position(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_position(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_position(inputs)
	return en_us2_plan_edit_position(inputs)
});
export { plan_edit_position as "plan-edit.position" }